import * as React from "react"
import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import {AutocompleteSeeker, SelectSeeker} from "@ui-seeker/core"
import {getPreviousDate, isEmpty} from "@ui-seeker/utils"

import {DATE_PERIODS} from "@constants";
import { setCommonFilters, resetCommonFilters, currentPeriod, dateRangePeriod, favFilterSelected } from "@signals"
import { favFiltersData } from "../Modal/FavFilter/@signals"
import useFavFilterModal from "../Modal/FavFilter/@hooks/useFavFilterModal"


export default function DIPFavFilter({ ...props }) {
    const { getFavouriteFilters } = useFavFilterModal()

    const placeholder = useSignal("Saved Filters")
    const filterSelected = useSignal(null)
    const disabled = useSignal(false)

    useEffect(() => {
        getFavouriteFilters(props?.dashboardKey, true, props.allowedFilters)
    }, [])

    const normalizedFavFilters = () => {
        const normalizedFilters = {}

        currentPeriod.value = favFilterSelected.value.currentPeriod
        normalizedFilters.currentPeriod = favFilterSelected.value.currentPeriod

        if (currentPeriod.value === DATE_PERIODS.CUSTOM) {
            normalizedFilters.startDate = favFilterSelected.value.startDate
            normalizedFilters.endDate = favFilterSelected.value.endDate
        }

        normalizedFilters.currentSingleDate = dateRangePeriod.value[1]
        normalizedFilters.prevSingleDate = getPreviousDate({ days: 1 }, dateRangePeriod.value[1])

        props.allowedFilters.forEach(key => {
            if (favFilterSelected.value.hasOwnProperty(key))
                normalizedFilters[key] = favFilterSelected.value[key]
        })

        return normalizedFilters
    }

    return <AutocompleteSeeker
        options={favFiltersData.value}
        label="Your Favourite Filters"
        value={favFilterSelected.value}
        placeholder={placeholder.value}
        disabled={disabled.value}
        onChange={e => {
            favFilterSelected.value = e.target.value
            if (!e.target.value)
                resetCommonFilters()
            const favFilters = normalizedFavFilters()
            setCommonFilters(favFilters)
        }}
        {...props}
    />
}